/**
 * src/platform/connectivity.web.ts — WEB connectivity shim (W2). Uses navigator.onLine.
 * Defaults to online when the API is unavailable (best-effort, matches web capture caveat).
 * NEVER imports @smartbox/* (mobile invariant 1).
 */
export async function isOnline(): Promise<boolean> {
  if (typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean') {
    return navigator.onLine;
  }
  return true;
}
